import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "input" }
const _hoisted_2 = { id: "search-input-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_SuggestBox = _resolveComponent("SuggestBox")!
  const _component_EngineBox = _resolveComponent("EngineBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "engine-select",
      class: "row-center scrub-backgound",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEngines = !_ctx.showEngines))
    }, [
      _createVNode(_component_SvgIcon, {
        name: _ctx.currentEngine.icon,
        size: "24px"
      }, null, 8, ["name"]),
      _createVNode(_component_SvgIcon, {
        name: "Down",
        size: "12px"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: "search-input",
        type: "search",
        class: "scrub-backgound",
        onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitSearch && _ctx.submitSearch(...args))),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSuggests($event.target as HTMLInputElement))),
        onOnfocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleFocus(true))),
        onOnblur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleFocus(false))),
        placeholder: "输入搜索内容",
        required: ""
      }, null, 32),
      _createElementVNode("i", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
      }, [
        _createVNode(_component_SvgIcon, {
          name: "Clear",
          size: "30px"
        })
      ])
    ]),
    _createElementVNode("div", {
      id: "search-button",
      class: "row-center scrub-backgound",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.directSearch && _ctx.directSearch(...args)))
    }, [
      _createVNode(_component_SvgIcon, {
        name: "Magnifier",
        size: "24px"
      })
    ]),
    _withDirectives(_createVNode(_component_SuggestBox, {
      suggests: _ctx.suggests,
      selected: _ctx.selected
    }, null, 8, ["suggests", "selected"]), [
      [_vShow, _ctx.searchInputFocused && _ctx.hasSuggestions]
    ]),
    _createVNode(_component_EngineBox, {
      class: _normalizeClass(`${_ctx.showEngines ? 'show':'hide'}-pop-y`),
      currentEngineIndex: _ctx.enginesData.currentEngineIndex,
      onSetEngineIndex: _ctx.setEngineIndex
    }, null, 8, ["class", "currentEngineIndex", "onSetEngineIndex"])
  ]))
}